import { jsx as _jsx } from "react/jsx-runtime";
import { useParams } from 'react-router-dom';
import AdminPreviewMode from '../../../layout/PreviewMode';
const AdminRallyPreviewPage = () => {
    const { id: rallyId, task: currentTaskNumber } = useParams();
    return (_jsx(AdminPreviewMode, { previewType: 'rally', rallyId: rallyId, currentTaskNumber: currentTaskNumber }));
};
export default AdminRallyPreviewPage;
